var classes = {"notificationDotWrapper":"PqjqK","notificationDot":"UC5Nw"};

export { classes as default };
